import { useState } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;
export const YOUTUBE_REDIRECT_URI = `${BACKEND_URL}/api/social/youtube/oauth-callback`;

// Bloco "Conectar com Google": usuário informa Client ID/Secret do próprio projeto e autoriza no Google
const YouTubeGoogleConnect = ({ clientId, clientSecret, onChange, onError }) => {
  const [starting, setStarting] = useState(false);
  const [copied, setCopied] = useState(false);
  const [localError, setLocalError] = useState('');
  const showError = (msg) => { setLocalError(msg); onError(msg); };

  const copyRedirect = async () => {
    try {
      await navigator.clipboard.writeText(YOUTUBE_REDIRECT_URI);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (_) { /* clipboard indisponível */ }
  };

  const startGoogleOAuth = async () => {
    if (!clientId || !clientSecret) {
      showError('Informe o Client ID e o Client Secret do Google antes de conectar.');
      return;
    }
    setLocalError('');
    setStarting(true);
    try {
      const { data } = await axios.post(`${API}/social/youtube/oauth-start`, {
        client_id: clientId,
        client_secret: clientSecret,
        redirect_uri: YOUTUBE_REDIRECT_URI,
        return_url: `${window.location.origin}/social-connect`,
      });
      window.location.assign(data.auth_url);
    } catch (err) {
      showError(err.response?.data?.detail || 'Não foi possível iniciar a conexão com o Google');
      setStarting(false);
    }
  };

  return (
    <div className="rounded-lg border border-red-200 bg-red-50 p-4 space-y-3" data-testid="youtube-google-connect">
      <h4 className="font-semibold text-red-800 flex items-center gap-2">
        <svg className="h-5 w-5" viewBox="0 0 24 24" aria-hidden="true">
          <path fill="#EA4335" d="M12 10.2v3.9h5.4c-.2 1.3-1.6 3.9-5.4 3.9-3.3 0-5.9-2.7-5.9-6s2.6-6 5.9-6c1.9 0 3.1.8 3.8 1.5l2.6-2.5C16.8 3.4 14.6 2.4 12 2.4 6.7 2.4 2.4 6.7 2.4 12s4.3 9.6 9.6 9.6c5.5 0 9.2-3.9 9.2-9.4 0-.6-.1-1.1-.2-1.6H12z"/>
        </svg>
        Conectar com Google (1 clique, renovação automática)
      </h4>

      <ol className="text-xs text-gray-700 list-decimal list-inside space-y-1">
        <li>No <a href="https://console.cloud.google.com/apis/credentials" target="_blank" rel="noopener noreferrer" className="text-blue-600 underline">Google Cloud Console</a>, crie um <strong>ID do cliente OAuth</strong> do tipo <em>Aplicativo da Web</em> (com a YouTube Data API v3 ativada).</li>
        <li>Em <strong>URIs de redirecionamento autorizados</strong>, adicione exatamente:</li>
      </ol>
      <div className="flex items-center gap-2">
        <code className="flex-1 text-xs bg-white border border-red-200 rounded px-2 py-1.5 break-all" data-testid="youtube-redirect-uri">{YOUTUBE_REDIRECT_URI}</code>
        <button type="button" onClick={copyRedirect} className="text-xs px-3 py-1.5 rounded bg-white border border-red-300 hover:bg-red-100" data-testid="youtube-copy-redirect-btn">
          {copied ? 'Copiado!' : 'Copiar'}
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        <div>
          <label className="block text-xs font-medium text-gray-700 mb-1">Client ID</label>
          <input
            type="text"
            value={clientId}
            onChange={(e) => onChange('client_id', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md text-xs"
            placeholder="xxx.apps.googleusercontent.com"
            data-testid="youtube-client-id-input"
          />
        </div>
        <div>
          <label className="block text-xs font-medium text-gray-700 mb-1">Client Secret</label>
          <input
            type="password"
            value={clientSecret}
            onChange={(e) => onChange('client_secret', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md text-xs"
            placeholder="GOCSPX-..."
            data-testid="youtube-client-secret-input"
          />
        </div>
      </div>

      {localError && (
        <p className="text-xs text-red-700 bg-white border border-red-300 rounded px-2 py-1.5" data-testid="youtube-google-connect-error">{localError}</p>
      )}
      <button
        type="button"
        onClick={startGoogleOAuth}
        disabled={starting}
        className="w-full py-2.5 rounded-md bg-red-600 hover:bg-red-700 text-white font-semibold text-sm disabled:opacity-50 transition-colors"
        data-testid="youtube-google-connect-btn"
      >
        {starting ? 'Redirecionando para o Google...' : 'Conectar com Google'}
      </button>
      <p className="text-[11px] text-gray-500">Você será levado ao Google para autorizar o canal e voltará aqui automaticamente. Suas credenciais ficam salvas apenas na sua conta.</p>
    </div>
  );
};

export default YouTubeGoogleConnect;
